<template>
    <div class="content-container">
        <div class="heading-section my-4 col-md-8 offset-md-2 row align-items-center">
            <h1 class="text-left font-bold text-normal mt-3 col-md-5">
                OUR ESTATES
            </h1>
            <span class="d-block text-left col text-normal">
                will be equipped with state-of-the-art amenities like Recreation Centre, Supermarket, Park, Internet Service and much more.
            </span>
        </div>
        <div class="body-section col-12">
            <div class="row mx-0 justify-content-between">
                <div class="card col-md-6 pb-4"
                    v-for="estate in estateList" :key="estate.id">
                    <div class="card-content estate-item">
                        <img :src="estate.main_photo" class="card-img-top" :alt="estate.title.rendered">
                        <span class="item-title">{{ estate.title.rendered }}</span>
                        <div class="card-body px-4">
                            <p class="card-text text-left text-normal mb-3" v-html="estate.content.rendered"></p>
                            <div class="row mt-2 mb-4">
                                <img :src="getImageUrl(estate.additional_photos, 1)" :alt="estate.title.rendered" class="col-md-6 mb-2 pr-md-2 img-fluid">
                                <img :src="getImageUrl(estate.additional_photos, 2)" :alt="estate.title.rendered" class="col-md-6 mb-2 pl-md-2 img-fluid">
                            </div>
                            <div class="row text-left align-items-end text-normal add_features">
                                <div class="col item-list">
                                    <span class="item d-block" v-for="(item, index) in estate.features_a.split('\n')"
                                        :key="index" v-html="item"></span>
                                </div>
                                <div class="col item-list">
                                    <span class="item d-block" v-for="(item, index) in estate.features_b.split('\n')"
                                        :key="index" v-html="item"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import estate2Main from '../../assets/estates/MAYYY-13.png'
// import estate3Main from '../../assets/estates/MAYYY-1.png'
// import estate4Main from '../../assets/estates/MAYYY.png'
// import estate5Main from '../../assets/estates/MAYYY-2.png'
// import estate6Main from '../../assets/estates/MAYYY-10.png'
// import estate7Main from '../../assets/estates/MAYYY-4.png'
// import estate8Main from '../../assets/estates/MAYYY-9.png'
// import estate9Main from '../../assets/estates/MAYYY-3.png'
// import estate10Main from '../../assets/estates/MAYYY-6.png'
// import estate11Main from '../../assets/estates/MAYYY-7.png'
// import estate12Main from '../../assets/estates/MAYYY-5.png'
// import estate13Main from '../../assets/estates/MAYYY-8.png'
// import estate14Main from '../../assets/estates/MAYYY-11.png'
// import estate15Main from '../../assets/estates/MAYYY-17.png'
// import estate16Main from '../../assets/estates/MAYYY-12.png'
// import estate17Main from '../../assets/estates/MAYYY-14.png'
// import estate18Main from '../../assets/estates/MAYYY-15.png'
// import estate19Main from '../../assets/estates/MAYYY-16.png'
// import estate2Photo1 from '../../assets/estates/IMG_5009-4.png'
// import estate2Photo2 from '../../assets/estates/IMG_5009-5.png'
// import estate3Photo1 from '../../assets/estates/IMG_5009-6.png'
// import estate3Photo2 from '../../assets/estates/IMG_5009-7.png'
// import estate4Photo1 from '../../assets/estates/IMG_5009-2.png'
// import estate4Photo2 from '../../assets/estates/IMG_5009-3.png'
// import estate5Photo1 from '../../assets/estates/IMG_5009-8.png'
// import estate5Photo2 from '../../assets/estates/IMG_5009-22.png'
// import estate6Photo1 from '../../assets/estates/IMG_5009-14.png'
// import estate6Photo2 from '../../assets/estates/IMG_5009-15.png'
// import estate7Photo1 from '../../assets/estates/IMG_5009-18.png'
// import estate7Photo2 from '../../assets/estates/IMG_5009-19.png'
// import estate8Photo1 from '../../assets/estates/IMG_5009-36.png'
// import estate8Photo2 from '../../assets/estates/IMG_5009-9.png'
// import estate9Photo1 from '../../assets/estates/IMG_5009-37.png'
// import estate9Photo2 from '../../assets/estates/IMG_5009-11.png'
// import estate10Photo1 from '../../assets/estates/IMG_5009-17.png'
// import estate10Photo2 from '../../assets/estates/IMG_5009-14.png'
// import estate11Photo1 from '../../assets/estates/IMG_5009-12.png'
// import estate11Photo2 from '../../assets/estates/IMG_5009-13.png'
// import estate12Photo1 from '../../assets/estates/IMG_5009-17.png'
// import estate12Photo2 from '../../assets/estates/IMG_5009-14.png'
// import estate13Photo1 from '../../assets/estates/IMG_5009-17.png'
// import estate13Photo2 from '../../assets/estates/IMG_5009-14.png'
// import estate14Photo1 from '../../assets/estates/IMG_5009-24.png'
// import estate14Photo2 from '../../assets/estates/IMG_5009-25.png'
// import estate15Photo1 from '../../assets/estates/IMG_5009-27.png'
// import estate15Photo2 from '../../assets/estates/IMG_5009-26.png'
// import estate16Photo1 from '../../assets/estates/IMG_5009-28.png'
// import estate16Photo2 from '../../assets/estates/IMG_5009-29.png'
// import estate17Photo1 from '../../assets/estates/IMG_5009-35.png'
// import estate17Photo2 from '../../assets/estates/IMG_5009-32.png'
// import estate18Photo1 from '../../assets/estates/IMG_5009-31.png'
// import estate18Photo2 from '../../assets/estates/IMG_5009-30.png'
// import estate19Photo1 from '../../assets/estates/IMG_5009-33.png'
// import estate19Photo2 from '../../assets/estates/IMG_5009-34.png'

export default {
    name: 'Estates',
    computed: {
        estateList() {
            return this.$store.state.estates
        },
    },
    methods: {
        getImageUrl(urlsString, index) {
            return urlsString.split("\n")[index - 1]
        }
    },
}
</script>

<style scoped>
@media (min-width: 1200px) {
    .main-content {
        padding: 25px 60px;
    }
}
@media (min-width: 992px) {
    .main-content {
        padding: 20px 40px;
        border-radius: 20px;
        box-shadow: 10px 10px 6px #0000000D;
    }
}
@media (min-width: 768px) {
    .main-content {
        padding: 15px 30px;
    }
}
.card {
    border: none;
    background: transparent;
}
.card p, .card-text >>> p {
    margin-bottom: 5px;
}
.estate-item {
    border-radius: 15px;
    box-shadow: 5px 5px 6px #0000001A;
    border: 0.5px solid #D1D1D1;
    height: 100%;
}
.item-title {
    font: Bold 20px/25px Segoe UI;
    letter-spacing: 1.2px;
    color: #FFFFFF;
    text-shadow: 0px 2px 6px #00000045;
    position: absolute;
    top: 15px;
    left: 30px;
    font-size: 13px;
}
.card-text {
    font-size: 12px;
    letter-spacing: 0.72px;
}
strong {
    font-size: 14px;
    display: block;
}
.img-content {
    margin-left: -2px;
    margin-top: -2px;
}
.overlay {
    border-radius: 7px;
    background-color: #6E216959;
    position: absolute;
    top: 0;
    left: 0;
    width: 97%;
    height: 98%;
}
.text-sm {
    font-size: 11px;
}
.body-section {
    margin: 30px 0 50px 0;
    padding: 0 2    0px
}
.download-btn {
    padding-left: 30px;
    padding-right: 30px;
    color: #fff!important;
    text-transform: capitalize;
    margin-top: 30px;
}
.text-description {
    color: #fff;
    position: absolute;
    width: 100%;
    top: 35%;
    text-align: center;
}
.add_features {
    font-size: 11px;
}
@media (max-width: 768px) {
    .add_features {
        font-size: 13px;
    }
    .item-list {
        flex: 0 0 100%;
        max-width: 100%;
        margin-top: 5px;
    }
}
.add_features >>> strong {
    display: block;
}
</style>